export default ({ getRoot }) => getRoot;
